import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import form from '@/mixins/crud-form';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'PAY_SET_DETAIL',
        create: 'PAY_SET_CREATE',
        update: 'ROLEPAY_SET_UPDATE'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [].concat(_toConsumableArray(this.mode === 'edit' ? [] : [{
        prop: 'market_id',
        default: '',
        label: this.$t('market_id'),
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "filterable": true,
              "name": "form_market_id",
              "clearable": true,
              "custom": true
            },
            "model": {
              value: _this.form.model.market_id,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "market_id", $$v);
              }
            }
          });
        }
      }]), [{
        prop: 'pay_api_key',
        default: '',
        label: '密钥',
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.pay_api_key,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "pay_api_key", $$v);
              }
            }
          });
        }
      }, {
        prop: 'currency',
        default: '',
        label: '货币类型',
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.currency,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "currency", $$v);
              }
            }
          });
        }
      }]);
    }
  },
  methods: {
    /**
     * @description 加载需要的字典数据
     */
    loadDict: function loadDict() {
      // 运营商信息
      this.loadDictOne({
        name: 'form_market_id',
        method: this.$api.MARKET_ALL,
        fields: 'id,user_name',
        path: 'list',
        label: 'market_info',
        value: 'id'
      });
    }
  }
};